import api from './api'

const leaveService = {
  // 取得假別列表
  getLeaveTypes: () => {
    return api.get('/leave/types')
  },

  // 取得假期額度
  getQuotas: (params) => {
    return api.get('/leave/quotas', { params })
  },

  // 建立請假申請
  createRequest: (data) => {
    return api.post('/leave/requests/create', data)
  },

  // 取得請假申請列表
  getRequests: (params) => {
    return api.get('/leave/requests', { params })
  },

  // 取得單筆請假申請
  getRequest: (id) => {
    return api.get(`/leave/requests/${id}`)
  },

  // 核准請假
  approveRequest: (id) => {
    return api.post(`/leave/requests/${id}/approve`)
  },

  // 拒絕請假
  rejectRequest: (id, comment) => {
    return api.post(`/leave/requests/${id}/reject`, { comment })
  },

  // 取得請假統計
  getStatistics: (params) => {
    return api.get('/leave/statistics', { params })
  },

  // 取得待審批的請假
  getPendingApprovals: () => {
    return api.get('/leave/approvals/pending')
  },

  // 取得代理人列表
  getDelegations: () => {
    return api.get('/leave/delegations')
  },

  // 創建代理人
  createDelegation: (data) => {
    return api.post('/leave/delegations/create', data)
  },

  // 刪除代理人
  deleteDelegation: (id) => {
    return api.post(`/leave/delegations/${id}/delete`)
  },

  // 取消請假申請
  cancelRequest: (id) => {
    return api.post(`/leave/requests/${id}/cancel`)
  },

  // 批次核准
  bulkApprove: (request_ids, comment = '') => {
    return api.post('/leave/requests/bulk-approve', { request_ids, comment })
  },

  // 批次駁回
  bulkReject: (request_ids, comment = '') => {
    return api.post('/leave/requests/bulk-reject', { request_ids, comment })
  },
}

export default leaveService
